import React from 'react';
import './PolicyBarbarismDescription.css';
import DescriptionValueWithIcon from "../../DescriptionValueWithIcon/DescriptionValueWithIcon";
import {
  POLICY_BARBARISM_MELEE_DAMAGE_WIN_POINTS_BONUS,
  POLICY_BARBARISM_UNIT_MELEE_BONUS,
  POLICY_BARBARISM_UNIT_SIZE_DECREASE_WITHOUT_SUPPLY
} from "../../../../configs/policy/barbarism";
import {WinPointsStat} from "../../../PlayerStat/stats/WinPointsStat";

const PolicyBarbarismDescription = () => {
  const unitD6 = <img
    className={'policy-description-icon-unit'}
    src={'/img/icons/unit d6 friend.png'}
    alt={'Отряд Пехота'}
    title={'\'Отряд Пехота (макс. размер 6)\''}
  />

  const unit = <img
    className={'policy-description-icon-unit policy-description-icon-unit-margin-right-left'}
    src={'/img/icons/unit d6 friend.png'}
    alt={'Отряд любого типа'}
    title={'Отряд любого типа'}
  />

  const unitEnd = <img
    className={'policy-description-icon-unit policy-description-icon-unit-margin-left'}
    src={'/img/icons/unit d6 friend.png'}
    alt={'Отряд любого типа'}
    title={'Отряд любого типа'}
  />

  const unitSize = <img
    className={'policy-description-icon'}
    src={'/img/icons/unit size.png'}
    alt={'Размер отряда'}
    title={'Размер отряда'}
  />;

  const supply = <img
    className={'policy-description-icon policy-description-icon-margin-left'}
    src={'/img/icons/supply.png'}
    alt={'Снабжение'}
    title={'Снабжение'}
  />;

  const discountElement = <img
    className={'policy-description-icon policy-description-icon-margin-left-end'}
    src={'/img/icons/percent white.png'}
    alt={'Скидка'}
    title={'Скидка'}
  />;

  const damageBonus = <span className={'text-war'}>
    {`+${POLICY_BARBARISM_UNIT_MELEE_BONUS}`}
  </span>;

  const damage = <img
    className={'policy-description-icon'}
    src={'/img/icons/damage.png'}
    alt={'Урон'}
    title={'Урон'}
  />;
  const melee = <img
    className={'policy-description-icon'}
    src={'/img/icons/barracks red.png'}
    alt={'Ближний бой'}
    title={'Ближний бой'}
  />;

  const damageBonusValueAndIcon = <DescriptionValueWithIcon
    className={'policy-description-icon-margin-left-end'}
    value={damageBonus}
    icon={<>{damage}{melee}</>}
  />

  const meleeDamageValueAndIcon = <DescriptionValueWithIcon
    className={'policy-description-icon-margin-left-end'}
    value={damage}
    icon={melee}
  />

  const sizeD6ValueAndIcon = <DescriptionValueWithIcon
    value={'1/6'}
    icon={unitSize}
  />

  const sizeDecreaseValueAndIcon = <DescriptionValueWithIcon
    className={'policy-description-icon-margin-right-left'}
    value={Math.abs(POLICY_BARBARISM_UNIT_SIZE_DECREASE_WITHOUT_SUPPLY)}
    icon={unitSize}
  />

  const winPoints = <WinPointsStat
    className={'policy-description-icon-margin-right-left'}
    text={POLICY_BARBARISM_MELEE_DAMAGE_WIN_POINTS_BONUS}
    noShrinkOnMobile={true}
    isDarkColor={true}
  />;

  return (
    <>
      <div className={'policy-description_line'}>
        {unitD6} ({sizeD6ValueAndIcon}) нанимаются
      </div>
      <div className={'policy-description_line'}>
        бесплатно {discountElement}.
      </div>
      <div className={'policy-description_line policy-description_line-margin-top-paragraph'}>
        Все {unit} имеют {damageBonusValueAndIcon}.
      </div>
      <div className={'policy-description_line'}>
        И теряют только {sizeDecreaseValueAndIcon} без {supply}.
      </div>
      <div className={'policy-description_line policy-description_line-margin-top-paragraph'}>
        По {winPoints} за каждый {unitEnd},
      </div>
      <div className={'policy-description_line'}>
        который наносит {meleeDamageValueAndIcon}.
      </div>
    </>
  );
};

export default PolicyBarbarismDescription;
